import React, { useEffect, useState } from "react";
import {
  Form,
  Select,
  Switch,
  Typography,
  Divider,
  Space,
  Button,
  message,
  theme,
} from "antd";
import apiRequest from "src/common/utils/apiRequest";
import LoadingPreview from "src/common/components/LoadingPreview";

const { Text, Title } = Typography;
const { Option } = Select;

const OtherSettings: React.FC = () => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const onFinish = async () => {
    setSaving(true);
    try {
      await form.validateFields();

      const API_REQUEST = new apiRequest(
        "user/profile/setting/other/edit",
        true
      );

      await API_REQUEST.send(
        form.getFieldsValue(),
        (response: { status: string; message: string }) => {
          if (response.status === "success") {
            message.success(response.message);
          } else {
            message.error(response.message);
          }
        }
      );
    } catch (errorInfo: any) {
      message.error(errorInfo.errorFields[0].errors[0]);
    }
    setSaving(false);
  };

  useEffect(() => {
    const getData = () => {
      setLoading(true);
      const API_REQUEST = new apiRequest(
        "user/profile/setting/other/get",
        true
      );

      API_REQUEST.send(
        {},
        (response: { status: string; data: any; message: string }) => {
          if (response.status === "success") {
            form.setFieldsValue(response.data);
            setLoading(false);
          } else {
            message.error(response.message);
          }
        }
      );
    };

    getData();
  }, []);

  return (
    <div>
      <Title level={3} style={{ marginTop: "0" }}>
        Other Settings
      </Title>
      <Text type="secondary">Manage other settings</Text>
      <Divider style={{ margin: "8px 0" }} />

      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        {loading ? (
          <LoadingPreview />
        ) : (
          <Form form={form} onFinish={onFinish} layout="vertical">
            {/* Theme Mode */}
            <div style={{ marginBottom: 12 }}>
              <Text strong>Theme Mode</Text>
              <div style={{ marginTop: 8 }}>
                <Form.Item
                  label={<Text type="secondary">Theme</Text>}
                  name="theme_mode"
                  valuePropName="checked"
                >
                  <Switch checkedChildren="Dark" unCheckedChildren="Light" />
                </Form.Item>
              </div>
            </div>

            <Divider style={{ margin: "12px 0" }} />

            <Form.Item style={{ marginTop: 8 }}>
              <Button type="primary" loading={saving} htmlType="submit" style={{ width: 120 }}>
                Save Changes
              </Button>
            </Form.Item>
          </Form>
        )}
      </Space>
    </div>
  );
};

export default OtherSettings;
